
import { Component, Prop, Event, EventEmitter, h } from '@stencil/core';
import { Color } from '../../interface';
import { Area, CallStatus } from './kone-elevators-interface';

@Component({
  tag: 'lar-kone-elevators-content',
  styleUrl: 'kone-elevators.scss',
  shadow: false,
  scoped: false
})
export class KoneElevatorsContent {
  @Prop() callableAreas: Area[] = [];
  @Prop() callStatus?: CallStatus;
  @Prop() loading?: boolean;
  @Prop() connection: boolean = true;
  @Prop() connectionError?: string;
  @Prop() color?: Color;

  @Event() callelevator!: EventEmitter;

  render() {
    const buttons = this.callableAreas.map(area => <lar-button
      expand="full"
      disabled={this.loading || !!this.callStatus || !this.connection}
      onClick={() => this.callelevator.emit(area.id)}
      color={this.color}
    >
      <lar-translate t={area.name} />
    </lar-button>);
    return [
      <h2>
        {(this.callStatus === CallStatus.APPROVED || this.callStatus === CallStatus.CREATED) && <span><lar-translate t="elevators.on_way" /></span>}
        {this.callStatus === CallStatus.CANCELLED && <span><lar-translate t="elevators.call_canceled" /></span>}
        {this.callStatus === CallStatus.TIMEOUT && <span><lar-translate t="elevators.call_timeout" /></span>}
        &nbsp;
        {!this.connection && <span class="error"><lar-translate t={this.connectionError} /></span>}
      </h2>,
      <lar-list-header>{buttons.length > 0 && <lar-translate t="elevators.callto"/>}</lar-list-header>,
      <lar-button-group>
       {buttons}
      </lar-button-group>
    ];
  }
}